// extracted by mini-css-extract-plugin
export default {"finished_mark":"AdvertisementCreateForm_finished_mark__5HM0L","visible":"AdvertisementCreateForm_visible__p42Dg","shimmer":"AdvertisementCreateForm_shimmer__3YrVD"};